import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router';
import { Layout } from './components/layout';
import { Spinner } from './components/ui';
import { useAuth } from './lib/auth';
import { AgendaPage } from './pages/agenda';
import { AuditPage } from './pages/audit';
import { CourseDetailPage, CoursesPage, TurmaPage } from './pages/courses';
import { DashboardPage } from './pages/dashboard';
import { LoginPage } from './pages/login';
import { OrderDetailPage } from './pages/order-detail';
import { OrdersBoardPage, OrdersListPage } from './pages/orders-board';
import { SettingsPage } from './pages/settings';
import { ReportsPage } from './pages/reports';
import { TarefasPage } from './pages/tarefas';
import { UsersPage } from './pages/users';

export function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route element={<RequireAuth />}>
          <Route element={<Layout />}>
            <Route index element={<DashboardPage />} />
            <Route path="pedidos" element={<OrdersBoardPage />} />
            <Route path="pedidos/lista" element={<OrdersListPage />} />
            <Route path="pedidos/:code" element={<OrderDetailPage />} />
            <Route path="cursos" element={<CoursesPage />} />
            <Route path="cursos/:id" element={<CourseDetailPage />} />
            <Route path="cursos/:id/turma/:sid" element={<TurmaPage />} />
            <Route path="agenda" element={<AgendaPage />} />
            <Route path="tarefas" element={<TarefasPage />} />
            <Route path="configuracoes" element={<SettingsPage />} />
            <Route path="usuarios" element={<UsersPage />} />
            <Route path="auditoria" element={<AuditPage />} />
            <Route path="relatorios" element={<ReportsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function RequireAuth() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner label="Carregando o painel…" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return <Outlet />;
}
